import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  deliveryMaterial,
  getDeliveryDetailsId,
  listStockPartsDelivery,
} from './DeliveryMaterial.service';
import { deliveryMaterialRequest } from './DeliveryMaterial.types';
import notificationError from '@/utils/functions/notificationError';

export function useDeliveryMaterial() {
  const intl = useIntl();

  const mutation = useMutation(deliveryMaterial, {
    onSuccess() {
      notification.success({
        message: intl.formatMessage({
          id: 'stock.DeliveryOdMaterial.success',
        }),
        description: intl.formatMessage({
          id: 'stock.DeliveryOdMaterial.success.message',
        }),
      });
    },
    onError(error) {
      notificationError(error, {
        translate: (errors) =>
          errors.map((err) =>
            err.includes('stock.errors.stock_not_available')
              ? 'Estoque indisponivel.'
              : err,
          ),
      });
    },
  });

  return mutation;
}

export function useStockPartsDelivery(
  params?: deliveryMaterialRequest,
  enabled?: boolean,
) {
  const query = useInfiniteQuery(
    ['stockItems', { ...params }],
    ({ pageParam }) => {
      const req: deliveryMaterialRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listStockPartsDelivery(req);
    },
    {
      enabled,
      getNextPageParam: (lastPage) => lastPage.result.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useDeliveryDetail(id?: string) {
  const result = useQuery(
    ['deliveryDetail', id],
    () => getDeliveryDetailsId(id),
    { enabled: !!id },
  );

  useServiceError(result.error);

  return result;
}

export function useDeliveryDetailsId(id?: string) {
  return useQuery(['delivery/details', id], () => getDeliveryDetailsId(id), {
    enabled: !!id,
    onError(error) {
      notificationError(error);
    },
  });
}
